/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IDeleteInternalRegulationObligationRiskMutationVariables = Types.Exact<{
  input: Types.IDeleteInternalRegulationObligationRiskInput;
}>;

export type IDeleteInternalRegulationObligationRiskMutation = {
  __typename?: 'Mutation';
  deleteInternalRegulationObligationRisk: {
    __typename?: 'InternalRegulationObligationRisk';
    id: string;
    name?: string | null;
    approvalStatus?: Types.IInternalRegulationObligationApprovalStatus | null;
  };
};

export const DeleteInternalRegulationObligationRiskDocument = gql`
  mutation DeleteInternalRegulationObligationRisk($input: DeleteInternalRegulationObligationRiskInput!) {
    deleteInternalRegulationObligationRisk(input: $input) {
      id
      name
      approvalStatus
    }
  }
`;
export type IDeleteInternalRegulationObligationRiskMutationFn = Apollo.MutationFunction<
  IDeleteInternalRegulationObligationRiskMutation,
  IDeleteInternalRegulationObligationRiskMutationVariables
>;

/**
 * __useDeleteInternalRegulationObligationRiskMutation__
 *
 * To run a mutation, you first call `useDeleteInternalRegulationObligationRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInternalRegulationObligationRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInternalRegulationObligationRiskMutation, { data, loading, error }] = useDeleteInternalRegulationObligationRiskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInternalRegulationObligationRiskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteInternalRegulationObligationRiskMutation,
    IDeleteInternalRegulationObligationRiskMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    IDeleteInternalRegulationObligationRiskMutation,
    IDeleteInternalRegulationObligationRiskMutationVariables
  >(DeleteInternalRegulationObligationRiskDocument, options);
}
export type DeleteInternalRegulationObligationRiskMutationHookResult = ReturnType<
  typeof useDeleteInternalRegulationObligationRiskMutation
>;
export type DeleteInternalRegulationObligationRiskMutationResult =
  Apollo.MutationResult<IDeleteInternalRegulationObligationRiskMutation>;
export type DeleteInternalRegulationObligationRiskMutationOptions = Apollo.BaseMutationOptions<
  IDeleteInternalRegulationObligationRiskMutation,
  IDeleteInternalRegulationObligationRiskMutationVariables
>;
